import { render, staticRenderFns } from "./SolveNonDelivery.vue?vue&type=template&id=31e60aed&"
import script from "./SolveNonDelivery.vue?vue&type=script&lang=js&"
export * from "./SolveNonDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SolveNonDelivery.vue?vue&type=style&index=0&id=31e60aed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports